import React, { useContext, useState } from 'react'
import { Button, ListMenu, ListMenuButton, Modal, NotificationManagerContext,
   Popover, Spacer, Text, View } from 'oio-react'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { settingsSiteUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import MetadataListItemRow from '~/AdminWorkspace/components/MetadataListItemRow'
import FieldUpsert from './FieldUpsert'

const CustomMetadata = () => {
   const history = useHistory()
   const match = useRouteMatch()
   const [modalIsOpen, setModalIsOpen] = useState(true)
   const [popoverConfig, setPopoverConfig] = useState({
      anchorElement: null,
      focusedValue: null,
      isOpen: false
   })

   const { organization } = useOrganization()
   const { updateOrganization } = useUpdateOrganization()
   const { showNotification } = useContext(NotificationManagerContext)
   const theme = useContext(ThemeContext)

   const handleRemoveField = async (key) => {
      try {
         await updateOrganization({
            metadata: [{
               operation: 'remove',
               remove: key
            }]
         })

         showNotification({
            message: 'Metadata field was removed successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         showNotification({
            message: err?.graphQLErrors?.map(e => e.message).join(', ') || err.message,
            title: 'Error',
            type: 'error'
         })
      }
   }

   const handleClosePopover = () => {
      setPopoverConfig(config => ({
         ...config,
         isOpen: false,
         anchorElement: null
      }))
   }

   return (
      <View>
         <ProtoReturnBar
            display="block[a-d] none[e-f]"
            returnLinkName="Site Settings"
            returnLinkTo={settingsSiteUrl}
         />
         <View display="flex" justifyContent="center">
            <View
               width="100%"
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <View paddingRight="30px[b-c] 50px[d-f]">
                     <ProtoHeadingBlock
                        title="Custom Metadata"
                        description="Custom Metadata is an advanced feature that lets you create data that can be used dynamically throughout your site. This feature is available to enterprise customers only"
                     />
                  </View>
                  <View flex="0 0 auto" paddingTop="30px">
                     <Button
                        linkTo={`${match.url}/create`}
                        name="Add Field"
                        color={theme.protoSettingsHighlightBackgroundColor}
                        textColor={theme.protoSettingsHighlightForegroundColor}
                        textWeight="medium"
                        size="md"
                        textSize="0.9"
                        padding="25px"
                     />
                  </View>
               </View>
               <Spacer size="6" />
               {organization.metadata.length === 0 && (
                  <View
                     float="left"
                     textAlign="center"
                     backgroundColor="#fff"
                     width="100%"
                     padding="30px">
                     <Text size="1.5" color="#666">
                        No metadata fields have been created yet
                     </Text>
                  </View>
               )}
               {organization.metadata.map(field => (
                  <MetadataListItemRow
                     key={field.id}
                     keyName={field.key}
                     id={field.id}
                     description={field.description}
                     value={field.value}
                     onOptionsButtonClick={(e) => {
                        setPopoverConfig({
                           isOpen: true,
                           anchorElement: e.currentTarget,
                           focusedValue: field
                        })
                     }}
                  />
               ))}
            </View>
         </View>
         <Popover
            anchorElement={popoverConfig.anchorElement}
            anchorOriginHorizontal="right"
            anchorOriginVertical="top"
            backgroundColor="#fff"
            borderRadius="5px"
            width="150px"
            onBodyClick={handleClosePopover}
            open={popoverConfig.isOpen}>
            <View
               float="left"
               width="100%"
               backgroundColor="#fff"
               borderRadius="5px"
               boxShadow="3px 3px 12px rgba(0,0,0,0.2)">
               {popoverConfig.focusedValue && (
                  <ListMenu buttonSize="sm">
                     <ListMenuButton
                        linkTo={`${match.url}/update/${popoverConfig.focusedValue.key}`}
                        name="Edit Field"
                     />
                     <ListMenuButton
                        onClick={() => handleRemoveField(popoverConfig.focusedValue.key)}
                        name="Remove Field"
                     />
                  </ListMenu>
               )}
            </View>
         </Popover>
         <Switch>
            <Route path={`${match.url}/:operationName(create|update)/:metadataKey?`}>
               <Modal
                  borderRadius="5px"
                  width="100%[a-b] 270px[c-f]"
                  onCloseComplete={() => {
                     history.push(match.url)
                     setModalIsOpen(true)
                  }}
                  onCloseTrigger={() => setModalIsOpen(false)}
                  open={modalIsOpen}>
                  <FieldUpsert
                     onCloseButtonClick={() => setModalIsOpen(false)}
                     onSave={() => setModalIsOpen(false)}
                  />
               </Modal>
            </Route>
         </Switch>
      </View>
   )
}

export default CustomMetadata
